import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import SwiperCore from "swiper";
import { Autoplay, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "./Home.css";

const teamData = [
  {
    name: "Dr. Preeti Meena",
    role: "Gynecologist",
    img: "assets/img/all-images/team/Doctor - Demo.png",
    element: "assets/img/elements/elements13.webp",
  },
  {
    name: "Dr. Rohit Chhari",
    role: "MD Medicine",
    img: "assets/img/all-images/team/Doctor - Demo.png",
    element: "assets/img/elements/elements14.webp",
  },
  {
    name: "Dr. Vishal Patil",
    role: "General Surgeon",
    img: "assets/img/all-images/team/Doctor - Demo.png",
    element: "assets/img/elements/elements16.webp",
  },
  {
    name: "Dr. Shailendra Pandey",
    role: "Orthopedic Surgeon",
    img: "assets/img/all-images/team/Doctor - Demo.png",
    element: "assets/img/elements/elements17.webp",
  },
  {
    name: "Dr. Devendra Dhakad",
    role: "Urologist",
    img: "assets/img/all-images/team/Doctor - Demo.png",
    element: "assets/img/elements/elements18.png",
  },
  {
    name: "Dr. Mridul Shahi",
    role: "Neurosurgeon",
    img: "assets/img/all-images/team/Doctor - Demo.png",
    element: "assets/img/elements/elements13.webp",
  },
  {
    name: "Dr. Manohar Malviye",
    role: "Plastic Surgeon",
    img: "assets/img/all-images/team/Doctor - Demo.png",
    element: "assets/img/elements/elements14.webp",
  },
  {
    name: "Dr. Tejinder Singh Ajmani",
    role: "Anesthesiologist",
    img: "assets/img/all-images/team/Doctor - Demo.png",
    element: "assets/img/elements/elements16.webp",
  },
  {
    name: "Dr. Rahul Agrawal",
    role: "Oncologist",
    img: "assets/img/all-images/team/Doctor - Demo.png",
    element: "assets/img/elements/elements17.webp",
  },
  {
    name: "Dr. Pushpraj Singh",
    role: "Dental Surgeon",
    img: "assets/img/all-images/team/Doctor - Demo.png",
    element: "assets/img/elements/elements18.png",
  },
  {
    name: "Dr. Afreen Ali",
    role: "MD Medicine",
    img: "assets/img/all-images/team/Doctor - Demo.png",
    element: "assets/img/elements/elements13.webp",
  },

  /* RMO */
  {
    name: "Dr. Shahbaz Khan",
    role: "Resident Medical Officer (RMO)",
    img: "assets/img/all-images/team/Doctor - Demo.png",
    element: "assets/img/elements/elements14.webp",
  },
  {
    name: "Dr. Asha Dagur",
    role: "Resident Medical Officer (RMO)",
    img: "assets/img/all-images/team/Doctor - Demo.png",
    element: "assets/img/elements/elements16.webp",
  },
  {
    name: "Dr. Vishal Jain",
    role: "Resident Medical Officer (RMO)",
    img: "assets/img/all-images/team/Doctor - Demo.png",
    element: "assets/img/elements/elements17.webp",
  },
  {
    name: "Dr. Yashfeen Rehman",
    role: "Resident Medical Officer (RMO)",
    img: "assets/img/all-images/team/Doctor - Demo.png",
    element: "assets/img/elements/elements18.png",
  },
];

SwiperCore.use([Autoplay, Navigation]);
export default function TeamSection() {
  return (
    <div className="team4-section-area sp1">
      <div className="container">
        {/* Heading */}
        <div className="row">
          <div className="col-lg-5 m-auto">
            <div className="heading4 text-center space-margin60">
              <h5 className="vl-section-subtitle">
                JEEVANDAAN Hospital <span>|</span> Our Team
              </h5>
              <div className="space24" />
              <h2 className="vl-section-title text-anime-style-3">
                Meet Our Expert Medical Team
              </h2>
            </div>
          </div>
        </div>

        {/* Swiper slider */}
        <div className="row">
          <div className="col-lg-12">
            <Swiper
              spaceBetween={30}
              slidesPerView={4}
              navigation
              loop
              autoplay={{ delay: 3000 }}
              breakpoints={{
                0: { slidesPerView: 1 },    // mobile
                768: { slidesPerView: 2 },  // tablet
                992: { slidesPerView: 3 },  // small desktop
                1200: { slidesPerView: 4 }, // large desktop
              }}
            >
              {teamData.map((member, idx) => (
                <SwiperSlide key={idx}>
                  <div className="team4-slider-area owl-carousel">
                    <div className="team4-boxarea"><div className="img1">
                      <img src={member.img} alt={member.name} className="team-img10" />
                      <img src={member.element} alt="element" className="elements13 keyframe6" />
                    </div>
                      <div className="name-area">
                        <a href="doctor.html">{member.name}</a>
                        <div className="space12" />
                        <p>{member.role}</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>

        {/* Button */}
        <div className="col-lg-12">
          <div className="space101" />
          <div className="btn-area1 text-center">
            <a href="doctor.html" className="vl-btn4">Join Our Team <span><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path fillRule="evenodd" clipRule="evenodd" d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 16.9371 5.06294 21.75 11 21.75C16.9371 21.75 21.75 16.9371 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM10 7C9.5955 7 9.2309 7.24364 9.0761 7.61732C8.92134 7.99099 9.0069 8.42111 9.2929 8.70711L10.5858 10L7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L12 11.4142L13.2929 12.7071C13.5789 12.9931 14.009 13.0787 14.3827 12.9239C14.7564 12.7691 15 12.4045 15 12V8C15 7.44772 14.5523 7 14 7H10Z" fill="white" />
            </svg></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
